module.exports = __webpack_public_path__ + "/images/ico-social-color-www.9f4d217.svg";